import { QueryFunctionContext } from '@tanstack/react-query';

import { baseQuery } from '../baseQuery';
import type { PaginatedApiResponse, Ticket } from 'types';

type TicketsQueryParams = {
  currentPage: number;
  recordsPerPage: number;
  status: '0' | '1' | null;
};

export const getCustomerTickets = async ({
  queryKey,
}: QueryFunctionContext<[string, string, customerId: string | undefined, TicketsQueryParams]>) => {
  const customerId = queryKey[2];
  const { currentPage, recordsPerPage, status } = queryKey[3];

  const customer = customerId ? `&customer_id=${customerId}` : '';
  const statusFilter = status ? `&status=${status}` : '';

  const data: PaginatedApiResponse<Ticket[]> = await baseQuery(
    `customer-tickets?page=${currentPage}&per_page=${recordsPerPage}${customer}${statusFilter}`,
  );

  return data;
};
